import React from "react";
/* asset imports */
import vegetablesCart from "../assets/images/vegetables/vegetables-cart.png";

const HealthyFatsCart = ({ handleCartClick }) => {
  return (
    <div className="vegetables-cart" onClick={() => handleCartClick(3)}>
      <img src={vegetablesCart} alt="" />
    </div>
  );
};

export default HealthyFatsCart;
